import React from "react"
import CartIcon from "./Widgets/CartIcon/CartIcon"
import Styles from "./NavWidget.module.scss"
import UserIcon from "./Widgets/UserIcon/UserIcon"

export default () => (
  <div className={Styles.navwidget}>
    <UserIcon />
    <CartIcon />
  </div>
)
